import { BADGE_ID } from '@/types/shared/player'

export type MilestoneReward = {
  minLimit: number,
  reward: {
    goldenCoins: number,
    spins: number,
    tickets: number,
    badgeId?: BADGE_ID
  }
}

export enum MILESTONE_TYPES {
  PURCHASE = 'purchase',
  TRANSACTION = 'transaction',
  PATHWAYS = 'pathways',
}